import React from "react";
import PropTypes from "prop-types";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
  Toolbar,
  Typography
} from "@material-ui/core";

import { Row, Col } from "react-flexbox-grid/lib/index";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

const FAQModal = props => (
  <Dialog
    fullScreen
    open={props.faqModalOpen}
    onClose={props.onFAQClose}
    transition={Transition}
  >
    <AppBar color="primary">
      <Toolbar>
        <Typography variant="h6" style={{ color: "#fff" }}>
          CTD Data Download FAQ
        </Typography>
      </Toolbar>
    </AppBar>
    <DialogContent style={{ marginTop: 75 }}>
      <DialogContentText>
        <Row bottom="xs">
          <Col xs={12} md={8} lg={6} lgOffset={3} mdOffset={2}>
            <br />
            <Typography variant="h6">Csv and xlsx formats</Typography>
            <br />
            <Typography variant="subtitle1">
              The main difference between these two formats is that xlsx files
              have several worksheets, while csv data is output as one file. The
              repercussions of this are that every line of data in a csv file
              has both cast and data information. Downloading the vendor
              metadata or process log for every data point is too costly to
              performance, so these fields are only available in xlsx format.{" "}
              <br /> <br />
              Csv files will return &apos;null&apos; or &apos;undefined&apos;
              for unavailable data, while xlsx files will just contain blank
              cells.
            </Typography>
            <br />
            <Typography variant="h6">Text files</Typography>
            <br />
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              Hex/rsk
            </Typography>
            <Typography variant="subtitle1">
              Will return the Seabird hex or RBR hex or rsk file. These are
              original raw files that can be used in Seasoft or Ruskin. These
              files can be accessed for any processing stage.
            </Typography>
            <br />
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              Annotated text files
            </Typography>
            <Typography variant="subtitle1">
              This will return the engineering text file for RBR data, and the
              result of the datCnv processing step for Seabird data. These are
              text files that can be read or parsed. They can be accessed once a
              file has been annotated- for RBR this happens immediately and for
              Seabird it happens overnight.
            </Typography>
            <br />
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              Processed files
            </Typography>
            <Typography variant="subtitle1">
              This will return the text output of the final Seabird processing
              stage, binAvg. There is not an RBR equivalent.{" "}
            </Typography>
            <br />
            <Typography variant="h6">
              Bulk download and metadata download
            </Typography>
            <br />
            <Typography variant="subtitle1">
              One can download many files at once with the &apos;download all
              data&apos; button. Text files are compressed into a zip file,
              while data for csv and xlsx files is output in a single file.
              Text-intensive fields are omitted to increase download speed. For
              users just looking to scan available casts, the &apos;download all
              metadata&apos; just outputs the &apos;drops&apos; information,
              allowing many casts to be retrieved very quickly. These casts are
              organized first by station, then by time. All other download
              options are sorted by cast pk then time.
            </Typography>
            <br />
            <Typography variant="h6">Instrument variability</Typography>
            <br />
            <Typography variant="subtitle1">
              Some data types are only collected by certain instruments. In
              order to keep the formatting consistent for those using the data
              programatically, the same template is used for every download.
              This means several columns will almost always be empty. If you
              suspect certain data is missing, please review the text file
              and/or contact eims.support@hakai.org.
            </Typography>
            <br />
            <Typography variant="h6">Search options</Typography>
            <br />
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              Autofill
            </Typography>
            <Typography variant="subtitle1">
              The autofill options for survey and station are populated from
              what currently exists in the database. Selecting a workarea or
              survey will limit the possible options to those areas or surveys.
            </Typography>{" "}
            <br />
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              Cast pk
            </Typography>
            <Typography variant="subtitle1">
              Cast pks are relatively stable unique id numbers given to casts.
              However, if a file is reuploaded for whatever reason, a new id
              will be assigned. Searching by cast pk is available as it can be a
              useful way of revisiting particular casts over a short period of
              time, but please don&apos;t consider this a reliable long-term way
              of keeping track of a suite of casts.
            </Typography>{" "}
            <br />
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              RBR options
            </Typography>
            <Typography variant="subtitle1">
              The upcast is saved for RBR but not Seabird data. The default
              option is not to display this data, but it can be added with the
              &apos;include upcast&apos; toggle switch. <br />
              <br />
              The &apos;add extended buffer&apos; toggle switch includes data
              beyond the start and end time defined by the cast detection tool.
              This option is primarily used by the Marine Instrumentation
              Specialist and likely isn&apos;t advantageous to the average user.
            </Typography>
            <br />
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              Other
            </Typography>
            <Typography variant="subtitle1">
              Please note that searching for raw data will return the
              unprocessed version of all casts that match the search. Seeing a
              cast returned from a raw data search does not indicate that it is
              unprocessed- please refer to the &apos;processing stage&apos;
              field for this information.
              <br />
              <br />
              <br />
              If you have any questions or would like something added to this
              list, don&apos;t hesitate to contact eims.support@hakai.org.
            </Typography>
          </Col>
        </Row>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={props.onFAQClose} color="primary">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

FAQModal.propTypes = {
  faqModalOpen: PropTypes.bool.isRequired,
  onFAQClose: PropTypes.func.isRequired
};

export default FAQModal;
